<mat-card>
  <mat-card-title>404: Niet gevonden</mat-card-title>
  <mat-card-content> <p>Hey! We kunnen deze pagina niet vinden.</p> </mat-card-content>
  <mat-card-actions>
    <button mat-flat-button color="primary" routerLink="/">Terug naar overzicht</button>
  </mat-card-actions>
</mat-card>
